import React from 'react';
import getConfig from 'next/config';

const config = getConfig().publicRuntimeConfig;

const handleNavLinkClick = function () {
	window.location.href = '/';
};

const GiNavToggler = ({ logo }) => (
	<div className="d-flex" onClick={handleNavLinkClick}>
		<div>
			{logo === 'white' ? <img src={`${config.cdnUrl}/static/images/give-monthly-giving-white-2x.png`} width='175' alt="" /> : null }
			{logo === 'black' ? <img src={`${config.cdnUrl}/static/images/give-monthly-giving-2x.png`} width='175' alt="" /> : null }
			{logo !== 'black' && logo !== 'white'  ? <img src={`${config.cdnUrl}/static/images/give-monthly-giving-2x.png`} width='175' alt="" /> : null }
		</div>
	</div>
);

export default GiNavToggler;
